import ReactDOM from 'react-dom';

const generateHtmlFromComponent = (elements, cb) => {
  const d = document.createElement('div');
  ReactDOM.render(elements, d, () => {
    // d.insertAdjacentHTML(
    //   'afterbegin',
    //   '<link href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css" rel="stylesheet">',
    // );
    cb(d.innerHTML);
  });
};

export default generateHtmlFromComponent;
